import { useAppDispatch, useAppSelector } from '@/store';
import {
  selectTheme,
  selectThemeColors,
  setTheme,
  Theme,
  toggleTheme,
} from '@/store/features/theme.feature';
import { useCallback, useMemo } from 'react';

export const useTheme = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector(selectTheme);
  const colors = useAppSelector(selectThemeColors);

  const changeTheme = useCallback(
    (newTheme: Theme) => {
      dispatch(setTheme(newTheme));
    },
    [dispatch]
  );

  const toggle = useCallback(() => {
    dispatch(toggleTheme());
  }, [dispatch]);

  return useMemo(
    () => ({ theme, colors, setTheme: changeTheme, toggleTheme: toggle }),
    [theme, colors, changeTheme, toggle]
  );
};
